import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Utils } from "../../helper/utils.helper";
import { Campaign } from "../../models/campaign.model";
import { VoterFileService } from "../../services/voter-file.service";

let VoterFileL2Component = {
    selector: "vcVoterFileL2",
    templateUrl: "/angular/components/voter-file/voter-file-l2.component.html",
    bindings: {},
    controller: class VoterFileL2Controller {
        private readonly service: VoterFileService;
        private readonly $location: any;
        private readonly $timeout: any;
        private readonly utils: Utils;

        public error = false;
        public loading = false;
        public searchPath: any;
        public token: string;
        public activeCampaign: Campaign;
        public universe: any;
        public purchased: any;
        public contacts: any;
        public houses: any;

        constructor(
            VoterFileService: VoterFileService,
            $location: any,
            $timeout: any,
            CampaignDataProvider: CampaignDataProvider,
            Utils: Utils
        ) {
            this.service = VoterFileService;
            this.$location = $location;
            this.$timeout = $timeout;
            this.utils = Utils;

            this.searchPath = this.$location.search();
            this.token = this.searchPath.token;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
        }

        $onInit() {
            this.info();
        }

        import(tries?: number, erid?: number): void {
            if (!tries) {
                tries = 0;
            }
            this.loading = true;
            this.service
                .import_url({ token: this.token, erid: erid })
                .then((response: object) => {
                    const json = response["data"];
                    if (json.success == true) {
                        this.$timeout(() => {
                            let erid = json.id;
                            if (json.data.imsid == 3) {
                                this.$location.search("");
                                this.$location.path(
                                    "voterfiles/import/" + erid
                                );
                            } else {
                                this.$timeout(() => {
                                    this.import(tries++, erid);
                                }, 5000);
                            }
                        }, 5000);
                    } else {
                        if (json.code == 425) {
                            if (tries < 100)
                                this.$timeout(() => {
                                    this.import(tries++);
                                }, 5000);
                            else {
                                this.error = true;
                            }
                        } else {
                            this.error = true;
                        }
                    }
                });
        }

        info(): void {
            this.service
                .token_info({ token: this.token })
                .then((response: object) => {
                    const json = response["data"];
                    if (json.data) {
                        this.universe = json.data.name;
                        this.purchased = json.data.purchased;
                        this.contacts = json.data.total;
                        this.houses = json.data.houses;
                    }
                });
        }
    },
};

angular
    .module("voterFile")
    .component(VoterFileL2Component.selector, VoterFileL2Component);
